import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./store/index";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import AdminApp from "./pages/admin/AdminApp";

let persistor = persistStore(store);
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <MsalProvider instance={msalInstance} >
          <BrowserRouter>
            <App />
            <AdminApp />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>
    </PersistGate>
  </ReduxProvider>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
